import { render, staticRenderFns } from "./RequestBody.vue?vue&type=template&id=3275204e&scoped=true&"
import script from "./RequestBody.vue?vue&type=script&lang=js&"
export * from "./RequestBody.vue?vue&type=script&lang=js&"
import style0 from "./RequestBody.vue?vue&type=style&index=0&id=3275204e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275204e",
  null
  
)

export default component.exports
import {QExpansionItem,QSeparator,QItem,QItemSection,QIcon,QToggle,QTooltip} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QSeparator,QItem,QItemSection,QIcon,QToggle,QTooltip}, component.options.components || {})
